export const SECTIONS = [
  {
    id: "hero",
    label: "Hero",
    schema: [
      { key: "eyebrow", label: "Eyebrow", type: "text" },
      { key: "title", label: "Title", type: "text" },
      { key: "title_accent", label: "Title accent (gold)", type: "text" },
      { key: "subtitle", label: "Subtitle", type: "textarea" },
      { key: "cta_primary", label: "Primary button", type: "text" },
      { key: "cta_secondary", label: "Secondary button", type: "text" },
    ],
  },
  {
    id: "services",
    label: "Services",
    schema: [
      { key: "eyebrow", label: "Eyebrow", type: "text" },
      { key: "heading", label: "Heading", type: "text" },
      { key: "heading_accent", label: "Heading accent (gold)", type: "text" },
      {
        key: "cards",
        label: "Service cards (order matters: 1 = large card, 2 = tall card, 3–5 = small cards)",
        type: "list",
        canAdd: false,
        fields: [
          { key: "title", label: "Title", type: "text" },
          { key: "desc", label: "Description", type: "textarea" },
          { key: "tags", label: "Tags (comma separated)", type: "tags" },
        ],
      },
      {
        key: "stats",
        label: "Stats ribbon",
        type: "list",
        canAdd: false,
        fields: [
          { key: "value", label: "Value", type: "text" },
          { key: "label", label: "Label", type: "text" },
        ],
      },
    ],
  },
  {
    id: "portfolio",
    label: "Portfolio",
    schema: [
      { key: "eyebrow", label: "Eyebrow", type: "text" },
      { key: "heading", label: "Heading", type: "text" },
      { key: "heading_accent", label: "Heading accent (gold)", type: "text" },
      {
        key: "projects",
        label: "Projects",
        type: "list",
        canAdd: true,
        newItem: { name: "New Project", category: "", desc: "", tags: [] },
        fields: [
          { key: "name", label: "Name", type: "text" },
          { key: "category", label: "Category", type: "text" },
          { key: "desc", label: "Description", type: "textarea" },
          { key: "tags", label: "Tags (comma separated)", type: "tags" },
        ],
      },
    ],
  },
  {
    id: "contact",
    label: "Contact",
    schema: [
      { key: "eyebrow", label: "Eyebrow", type: "text" },
      { key: "heading", label: "Heading", type: "text" },
      { key: "heading_accent", label: "Heading accent (gold)", type: "text" },
      { key: "heading_suffix", label: "Heading suffix", type: "text" },
      { key: "blurb", label: "Blurb", type: "textarea" },
      { key: "info_lines", label: "Info lines", type: "stringlist" },
    ],
  },
  {
    id: "about",
    label: "About page",
    schema: [
      { key: "eyebrow", label: "Eyebrow", type: "text" },
      { key: "heading", label: "Heading", type: "text" },
      { key: "heading_accent", label: "Heading accent (gold)", type: "text" },
      { key: "paragraphs", label: "Paragraphs", type: "stringlist" },
      {
        key: "values",
        label: "Value cards",
        type: "list",
        canAdd: false,
        fields: [
          { key: "title", label: "Title", type: "text" },
          { key: "sub", label: "Subtitle", type: "text" },
          { key: "desc", label: "Description", type: "textarea" },
        ],
      },
      { key: "cta_heading", label: "CTA heading", type: "text" },
      { key: "cta_blurb", label: "CTA blurb", type: "textarea" },
      { key: "cta_button", label: "CTA button", type: "text" },
    ],
  },
  {
    id: "terms",
    label: "Terms page",
    schema: [
      { key: "heading", label: "Heading", type: "text" },
      { key: "heading_accent", label: "Heading accent (gold)", type: "text" },
      { key: "effective_date", label: "Effective date", type: "text" },
      {
        key: "sections",
        label: "Sections",
        type: "list",
        canAdd: true,
        newItem: { title: "New section", body: "" },
        fields: [
          { key: "title", label: "Title", type: "text" },
          { key: "body", label: "Body", type: "textarea" },
        ],
      },
    ],
  },
  {
    id: "footer",
    label: "Footer",
    schema: [
      { key: "tagline", label: "Tagline", type: "text" },
      { key: "copyright_name", label: "Copyright name", type: "text" },
    ],
  },
];
